
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { tabbarOptions, resetTextBylangKey } from "../../../libs/options.js"
export default{
components: { Tabbar, TabbarItem },
data() {
return {
tabbarList: []
}
},
created() {
this.tabbarList = resetTextBylangKey(tabbarOptions, this.$t('pageTab'))
},
methods: {
handleTab({ langKey, path }, index) { // tab点击
if (langKey === 'Service') { // 客服

this.$router.push({ path })
return
}
if (langKey === 'onlineCustomer' && window.LiveChatWidget) { // 在线客服
window.LiveChatWidget.call('maximize')
return
}
if (this.isApp) {
if (langKey === 'Home') common.emitAppMethods("JS_APP_HOME")
if (langKey === 'Deposit') common.emitAppMethods("JS_APP_Deposit") 
if (langKey === 'Discounts') common.emitAppMethods("JS_APP_ActivityList") 
} else {
this.$router.push({ path })
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/components/page-tab/index.vue